/* eslint-disable react/no-multi-comp */
import React, {Component} from 'react';
import moment from 'moment';
import 'moment/locale/sv';
import classNames from 'classnames';
import strings from 'utils/strings';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint} from '@fortawesome/free-solid-svg-icons';

const InfoRow = (props) => {
	// eslint-disable-next-line no-undefined
	if (props.condition !== undefined && !props.condition) {
		return null;
	}
	return (
		<p className="info__row">
			<span className="info__label">{props.name}</span>
			<span className="info__value">{props.children || props.value}</span>
		</p>
	);
};
class TestUserInfo extends Component {
	render() {
		const {testResult} = this.props;
		const {testUser} = testResult;
		const isTestOwner = testResult.isTestOwner;

		let completeName = '<dolt namn>';

		if (testUser.firstName) {
			completeName = `${testUser.firstName} ${testUser.lastName}`;
		}

		return (
			<div>
				<div className="lit-input-information">
					<button
						className={classNames('print-hide', {
							'lit-btn2 see-more': true,
							'bg-tertiary': true,
						})}
						onClick={() => {
							window.print();
						}}
					>
						<FontAwesomeIcon
							size="lg"
							className="lit-icon-btns"
							icon={faPrint}
						/>

						<p className="lit-btns-txt">
							{strings.printInformation}
						</p>
					</button>
				</div>
				<div className="info">
					<InfoRow
						condition={isTestOwner}
						name={`Namn: `}
						value={completeName}
					/>
					<InfoRow
						condition={isTestOwner}
						name={strings.dateofbirth}
						value={`${moment(testUser.birthdate).format('LL')}`}
					/>
					<InfoRow
						condition={testResult.completedAt}
						name={strings.testdate}
						value={`${moment(testResult.completedAt).format('LL')}`}
					/>
					<InfoRow
						name={strings.age}
						value={`${testUser.age.years} år och ${testUser.age.months} månader`}
					/>
					<InfoRow name={strings.sex}>
						{testUser.gender === 'm' &&
							(testUser.age.years < 18
								? strings.boy
								: strings.male)}
						{testUser.gender === 'f' &&
							(testUser.age.years < 18
								? strings.girl
								: strings.female)}
						{testUser.gender === 'u' && 'Ospecificerat'}
					</InfoRow>
					<div className="info__group info__group--education">
						<h3>{strings.education}</h3>
					</div>
					<InfoRow
						condition={isTestOwner}
						name={`Region: `}
						value={testUser.county}
					/>
					<InfoRow
						condition={isTestOwner}
						name={`Kommun: `}
						value={testUser.municipality}
					/>
					<InfoRow
						condition={isTestOwner}
						name={`Skola: `}
						value={testUser.school}
					/>
					<InfoRow name={`${strings.classGrade}: `}>
						{testUser.class === '0' && 'Sista året före skolstart'}
						{testUser.class === '1' && 'Årskurs 1'}
						{testUser.class === '2' && 'Årskurs 2'}
						{testUser.class === '3' && 'Årskurs 3'}
						{testUser.class === '4' && 'Årskurs 4'}
						{testUser.class === '5' && 'Årskurs 5'}
						{testUser.class === '6' && 'Årskurs 6'}
						{testUser.class === '7' && 'Årskurs 7'}
						{testUser.class === '8' && 'Årskurs 8'}
						{testUser.class === '9' && 'Årskurs 9'}
						{testUser.class === '10' && 'Årskurs 10'}

						{testUser.class === 'studiespesialisering' &&
							'Studieförberedande program'}
						{testUser.class === 'yrkesfag' && 'Yrkesprogram'}
						{testUser.class === 'bachelor' && 'Kandidatexamen'}
						{testUser.class === 'master' && 'Masterexamen'}
						{testUser.class === 'phd' && 'Doktorsexamen (PhD)'}
					</InfoRow>
					<div className="info__group">
						<h3>{strings.homeLanugage}</h3>
						<InfoRow
							name={`Växt upp i ett- eller tvåspråkigt hem? `}
						>
							{testUser.languagesInHome === 'one' && 'Ett språk'}
							{testUser.languagesInHome === 'two' && 'Två språk'}
							{testUser.languagesInHome === 'multiple' &&
								'Flera språk'}
						</InfoRow>
					</div>
				</div>
			</div>
		);
	}
}

export default TestUserInfo;
